import { Upload, UploadProps } from "antd";
import { useTranslation } from "react-i18next";

import { DocumentPasswordForm } from "domains/liquidity/components/AssetDocumentsTable/forms/DocumentPasswordForm";
import { AddFileFilled, CloseWindowOutlined } from "common/lib/components/Icons";
import { Spinner, DownloadDocumentIcon, DeleteDocumentIcon } from "common/lib/components";
import { apiService } from "common/shared";
import { getDateFromISO } from "common/shared/utils/date.utils";
import { getIconForFile } from "domains/documents/shared/utils";
import { useCustodialAgreement } from "common/shared-hooks";
import { useLiquiditySelector } from "domains/liquidity/store/liquidity.selectors";
import { IDocument } from "domains/documents/shared/types";

import "./AssetDocumentsListMobile.scss";

interface IProps {
  documents: IDocument[];
  uploadProps: UploadProps;
}

const AssetDocumentsListMobile = ({ documents, uploadProps }: IProps) => {
  const { t } = useTranslation([ "liquidity" ]);

  const { currentLiquidityRequest } = useLiquiditySelector();
  const { isCustodialAgreementActive, checkCustodialAgreement } = useCustodialAgreement();

  if (!currentLiquidityRequest) {
    return <Spinner />;
  }

  return (
    <div className="ben-asset-documents-list-mobile">
      <h4>Document</h4>
      <div onClick={ checkCustodialAgreement }>
        <Upload { ...uploadProps } openFileDialogOnClick={ isCustodialAgreementActive }>
          <div>
            <AddFileFilled className="ben-icon" width={ 30 } height={ 30 } />
            <p>{t("Add File")}</p>
          </div>
        </Upload>
      </div>

      {documents?.map((document, index) => {
        return (
          <div key={ `document-${ document.id || document.file_name }-${ index }` }>
            <div className="ben-files-list-item">
              {getIconForFile(document.file_name)}
              <p>{document.file_name}</p>
              <p className="ben-pl-2">
                {document.percent
                  ? `${ t("Uploading...") } ${ document.percent }%`
                  : `${ getDateFromISO(document.date_provided) }`}
              </p>

              <DownloadDocumentIcon
                documentId={ document.id }
                accountId={ currentLiquidityRequest.account_id }
                spinnerClassName="ben-download-file-icon"
                iconClassName="ben-download-file-icon"
              />

              {document.cancelToken ? (
                <CloseWindowOutlined
                  className="ben-delete-file-btn"
                  onClick={ () => apiService.cancel(document.cancelToken) }
                />
              ) : (
                <DeleteDocumentIcon type="asset" documentId={ document.id } iconClassName="ben-delete-file-btn" />
              )}
            </div>
            <div className="ben-files-list-item">
              {getIconForFile(document.file_name)}
              <p className="ben-w-45">{document.file_name}</p>
              <p className="ben-w-50">
                <DocumentPasswordForm key={ document.id } document={ document } />
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AssetDocumentsListMobile;
